const COURSE_CATEGORIES = Object.freeze([
  ['age-3-5', '#f94144'], ['age-6-7', '#f3722c'], ['age-8-9', '#f9844a'],
  ['age-10-13', '#f9c74f'], ['age-14-16', '#90be6d'], ['adults', '#44ad8e'],
  ['exam', '#55a09d'], ['storytime', '#5e7f9c'], ['chillout', '#2985ac'],
].map(([id, color], offerId) => Object.freeze({ id, offerId, color, labelKey: `public:courseDescriptions.${offerId}.name` })));

function getCourseCategory(id) {
  return COURSE_CATEGORIES.find(category => category.id === id);
}

module.exports = { COURSE_CATEGORIES, getCourseCategory };
